export default __webpack_public_path__ + "static/media/support_platform_drainage4.3dc91206.png";